// utils/paymeRequest.js

import axios from 'axios'

const paymeService = axios.create({
  baseURL: 'https://uz.equick.cn/api', // Payme 基础URL
  // baseURL: 'http://localhost:9530/api', // Payme 基础URL
  timeout: 10000 // 超时时间
})

// 请求拦截器
paymeService.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  config.headers['Authorization'] = 'Basic UGF5Y29tOkdJeFVJWUlLQHdrIzRoWllWSVhxMWhHWkRNdFcjUUp2RDgxSg=='
  return config
})

// 响应拦截器
paymeService.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code != 200) {
      return Promise.reject(new Error(res.msg || 'Payme Error'))
    }
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

export default paymeService
